import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

/** H1 страницы цен: «Цены [на платные услуги] в {лпу}». */
export default function getPricePageTitle(lpu: Lpu): string {
  const lpuName = tDynamic(lpu, 'name_pred')
    || tDynamic(lpu, 'name')
    || lpu.name_pred
    || lpu.name

  if (lpu.paid) {
    return `${tStatic('Цены')} ${tStatic('в')} ${lpuName}`
  }

  return `${tStatic('Цены')} ${tStatic('на платные услуги')} ${tStatic('в')} ${lpuName}`
}
